import React from 'react';
import { ModalType } from 'global/utils/ModalsHelper';
import { useRootStore } from 'store/rootStore';
import { observer } from 'mobx-react-lite';
import { toJS } from 'mobx';
import { Button, colors, Modal } from '@insurancemenu/imenu-components-lib';
import { WarningFilled, FileSignature, Person } from '@insurancemenu/imenu-components-lib/dist/icons';
import { createStyles } from 'components/common/modals/ActionModal/styles';
import PoweredByIM from 'components/common/general/PoweredByIM';
import clsx from 'clsx';
import { createStyles as createCustomStyles } from './styles';
import ActionModal from '../../ActionModal';

const NotificationModal = observer((): JSX.Element => {
  const {
    notificationModalStore: { modalData, isNotificationModalOpen, closeNotificationModal },
  } = useRootStore();
  const classes = createStyles(true);
  const customClasses = createCustomStyles();

  const { title, subtitle, type } = toJS(modalData);

  const ICON_MAP = {
    ERROR: <WarningFilled width="5.6rem" color={colors.orange[500]} />,
    ENROLL: <FileSignature width="5.6rem" color={colors.green[500]} />,
    CONTACT_ME: <Person width="7rem" color={colors.green[500]} />,
  };

  return (
    <>
      {type === 'ERROR' ? (
        <ActionModal
          show={isNotificationModalOpen}
          onClose={closeNotificationModal}
          title={title}
          subtitle={<p>{subtitle}</p>}
          modalType={ModalType.NOTIFICATION}
          closeButtonText="Close"
        />
      ) : (
        <Modal
          show={isNotificationModalOpen}
          onClose={closeNotificationModal}
          className={clsx(classes.modal, customClasses.notificationModal)}
          id={`${type}Modal`}
        >
          {ICON_MAP[type] || <></>}
          <p className={classes.modalTitle}>{title}</p>
          {subtitle && (
            <div className={classes.contentText}>
              {/* Help to highlight important details via store */}
              {/* eslint-disable-next-line react/no-danger */}
              <p dangerouslySetInnerHTML={{ __html: subtitle }} />
            </div>
          )}
          <footer className={clsx(classes.modalFooter, customClasses.footer)}>
            <Button type="outlined" onClick={closeNotificationModal} size="large">
              Ok, got it
            </Button>
            <PoweredByIM className={customClasses.poweredSection} />
          </footer>
        </Modal>
      )}
    </>
  );
});

export default NotificationModal;
